import { Component, OnDestroy, OnInit } from '@angular/core';
import { Functions, httpsCallableData } from '@angular/fire/functions';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import { User } from 'src/app/core/models/user';
import { AuthService } from 'src/app/core/services/auth.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-review-potential-instructors',
  templateUrl: './review-potential-instructors.component.html',
  styleUrl: './review-potential-instructors.component.scss'
})
export class ReviewPotentialInstructorsComponent implements OnInit, OnDestroy {

  subscriptionRef: any;
  unApprovedAsInstructors: User[];
  updatingStatus = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private userService: UserService,
    private notificationService: NotificationService,
    private toastr: ToastrService,
    private fns: Functions) {

  }


  ngOnInit(): void {
    this.subscriptionRef = this.authService.currentUser?.pipe(take(2)).subscribe(user => {
      if (user != null) {
        this.userService.getNewPotentialInstructors().subscribe(users => {
          this.unApprovedAsInstructors = users;
        });
      }
    });
  }

  async approveInstructor(user: User) {
    this.updatingStatus = false;
    user.approvedAsInstructor = true;
    user.rejectedAsInstructor = false;
    await this.userService.updateUser(user)
    const callable = httpsCallableData(this.fns, 'notifications-sendInstructorApprovedEmail');
    callable({ toUserId: user.userId, nameOfInstructor: `${user.firstName} ${user.lastName}` }).subscribe(data => {
      this.toastr.info('Instructor has been approved and notified');
      this.userService.getNewPotentialInstructors().subscribe(users => {
        this.unApprovedAsInstructors = users;
      });
    });
  }

  async rejectInstructor(user: User) {
    this.updatingStatus = false;
    user.approvedAsInstructor = false;
    user.rejectedAsInstructor = true;
    await this.userService.updateUser(user)
    const callable = httpsCallableData(this.fns, 'notifications-sendInstructorRejectedEmail');
    callable({ toUserId: user.userId, nameOfInstructor: `${user.firstName} ${user.lastName}` }).subscribe(data => {
      this.toastr.info('Instructor has been rejected and notified');
    });
  }

  updateInstructorStatus() {
    this.updatingStatus = true;
  }

  ngOnDestroy(): void {
    this.subscriptionRef.unsubscribe();
  }
}
